const GET_SUPER_REGION = 'GET_SUPER_REGION';
const SET_SUPER_REGION = 'SET_SUPER_REGION';

export {
    GET_SUPER_REGION,
    SET_SUPER_REGION
};
